import { Routes, Route } from "react-router-dom";
import Footer from "@/components/Footer";
import ErrorBoundary from "@/components/ErrorBoundary";
import BottomNavigation from "@/components/BottomNavigation";
import SurahList from "@/pages/SurahList";
import SurahRead from "@/pages/SurahRead";
import JuzList from "@/pages/JuzList";
import JuzRead from "@/pages/JuzRead";
import DoaList from "@/pages/DoaList";
import DoaRead from "@/pages/DoaRead";
import SmartSearch from "@/pages/SmartSearch";
import Help from "@/pages/Help";
import Qiblat from "@/pages/Qiblat";
import NotFound from "@/pages/NotFound";

export default function RoutesContainer() {
  return (
    <>
      <Routes>
        <Route path="/" element={<ErrorBoundary><SurahList /></ErrorBoundary>} />
        <Route path="/baca/:no" element={<ErrorBoundary><SurahRead /></ErrorBoundary>} />
        <Route path="/juz" element={<ErrorBoundary><JuzList /></ErrorBoundary>} />
        <Route path="/juz/:juzNumber" element={<ErrorBoundary><JuzRead /></ErrorBoundary>} />
        <Route path="/doa" element={<ErrorBoundary><DoaList /></ErrorBoundary>} />
        <Route path="/doa/:id" element={<ErrorBoundary><DoaRead /></ErrorBoundary>} />
        <Route path="/tanya-ai" element={<ErrorBoundary><SmartSearch /></ErrorBoundary>} />
        <Route path="/bantuan" element={<ErrorBoundary><Help /></ErrorBoundary>} />
        <Route path="/qiblat" element={<ErrorBoundary><Qiblat /></ErrorBoundary>} />
        <Route path="*" element={<NotFound />} />
      </Routes>
      {/* Footer — disembunyikan di mobile karena sudah ada BottomNavigation */}
      <div className="hidden md:block">
        <Footer />
      </div>
      {/* Bottom Navigation — hanya tampil di mobile (md:hidden di dalam komponen) */}
      <BottomNavigation />
    </>
  );
}
